import React from 'react'
import './Button.css'

const Button = (props) => {
  return (
    <a href={props.link} target="_blank" rel='noreferrer'>
      <button className="project_button">
        <span class="text">{props.label}</span>
      </button>
    </a>
  );
}

export default Button